module.exports = __webpack_public_path__ + "static/img/Moeaki-Fotuaika.3b3e9ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Moeaki-Fotuaika.jpg
// module id = diwp
// module chunks = 0